/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Orders_Rental_BadgeInputs */

const en_seller_orders_rental_badge = /** @type {(inputs: Seller_Orders_Rental_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rental`)
};

const es_seller_orders_rental_badge = /** @type {(inputs: Seller_Orders_Rental_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alquiler`)
};

const fr_seller_orders_rental_badge = /** @type {(inputs: Seller_Orders_Rental_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Location`)
};

const de_seller_orders_rental_badge = /** @type {(inputs: Seller_Orders_Rental_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miete`)
};

const id_seller_orders_rental_badge = /** @type {(inputs: Seller_Orders_Rental_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sewa`)
};

/** @type {(inputs: Seller_Orders_Rental_BadgeInputs) => LocalizedString} */
const ja_seller_orders_rental_badge = en_seller_orders_rental_badge;

/** @type {(inputs: Seller_Orders_Rental_BadgeInputs) => LocalizedString} */
const zh_seller_orders_rental_badge = en_seller_orders_rental_badge;

/** @type {(inputs: Seller_Orders_Rental_BadgeInputs) => LocalizedString} */
const ar_seller_orders_rental_badge = en_seller_orders_rental_badge;

/** @type {(inputs: Seller_Orders_Rental_BadgeInputs) => LocalizedString} */
const it_seller_orders_rental_badge = en_seller_orders_rental_badge;

/** @type {(inputs: Seller_Orders_Rental_BadgeInputs) => LocalizedString} */
const ru_seller_orders_rental_badge = en_seller_orders_rental_badge;

/** @type {(inputs: Seller_Orders_Rental_BadgeInputs) => LocalizedString} */
const pt_seller_orders_rental_badge = en_seller_orders_rental_badge;

/** @type {(inputs: Seller_Orders_Rental_BadgeInputs) => LocalizedString} */
const ko_seller_orders_rental_badge = en_seller_orders_rental_badge;

/**
* | output |
* | --- |
* | "Rental" |
*
* @param {Seller_Orders_Rental_BadgeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const seller_orders_rental_badge = /** @type {((inputs?: Seller_Orders_Rental_BadgeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Orders_Rental_BadgeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seller_orders_rental_badge(inputs)
	if (locale === "es") return es_seller_orders_rental_badge(inputs)
	if (locale === "fr") return fr_seller_orders_rental_badge(inputs)
	if (locale === "de") return de_seller_orders_rental_badge(inputs)
	if (locale === "ja") return ja_seller_orders_rental_badge(inputs)
	if (locale === "zh") return zh_seller_orders_rental_badge(inputs)
	if (locale === "ar") return ar_seller_orders_rental_badge(inputs)
	if (locale === "id") return id_seller_orders_rental_badge(inputs)
	if (locale === "it") return it_seller_orders_rental_badge(inputs)
	if (locale === "ru") return ru_seller_orders_rental_badge(inputs)
	if (locale === "pt") return pt_seller_orders_rental_badge(inputs)
	return ko_seller_orders_rental_badge(inputs)
});